<template>
  <div class="flex-1 flex-col justify-center items-center pointer-events-none">
    <LazyImg :src="emptyImg" width="220px" minHeight="100px" />

    <p class="text-color-white text-center mt-10 text-12">
      <span>{{ $t("A0277") }}</span>
    </p>
  </div>
</template>
<script setup>
import emptyImg from '@images/empty.png'

</script>
